import { forEachNode } from '@/shared'

const btn = document.querySelectorAll('.js-custom-select')

forEachNode(btn, (item) => {
  const select = item.querySelector('select')
  const text = item.querySelector('.js-custom-select-text')

  select.addEventListener('change', (e) => {
    e.preventDefault()

    const selectedOption = [...e.srcElement].find(option => option.selected).text
    text.textContent = selectedOption
  }, false)
})



// WEBPACK FOOTER //
// ./src/modules/custom-select.js